import { Box, Typography } from "@mui/material";
import type { ReactNode } from "react";

export type ListValues = Array<{ label: string; value?: ReactNode }>;

type Props = {
  values: ListValues;
};

export const ValueItems = ({ values }: Props) => (
  <>
    {values.map(({ label, value }) => (
      <Box
        key={label}
        sx={{ display: "flex", justifyContent: "space-between" }}
      >
        <Typography fontWeight={400}>{label}</Typography>
        <Typography fontSize={16} fontWeight={500} textAlign="right">
          {value}
        </Typography>
      </Box>
    ))}
  </>
);
